import React, { useEffect, useCallback, useState} from 'react';
import PlayheadEffect from 'effects/live/PlayheadEffect.js';
import {connect} from 'react-redux';

const TrackSpeedButton = ({track, speed}) => { 
    const onClickSpeed = useCallback(() => {
        if (!track.playheadEffect) {
            // create a new playhead effect
            let fx = new PlayheadEffect(track);
            track.liveEffects.addEffect(fx);
        }
        if (speed === 4) {
            track.playheadEffect.speedFactorParameter.set(0.25, false);
        } else {
            track.playheadEffect.speedFactorParameter.set(speed*2, false);
        }
    }, [speed, track]);

    return (
        <div
          onClick={onClickSpeed}
          className="track-speed-button pushable">
          {speed}x
        </div>);
};

const selectors = {};

const getSpeedSelector = (track) => {
    if (track.playheadEffect) {
        return track.playheadEffect.speedFactor;
    }
    return 1;
}

const mapStateToProps = (state, props) => {
  return {
      speed: getSpeedSelector(props.track)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackSpeedButton);
